(function () {
  'use strict';

  var gallery  = document.getElementById('vrp-gallery');
  var thumbs   = document.getElementById('vrp-thumbs');
  var mainEl   = document.getElementById('vrp-main');
  var mainImg  = document.getElementById('vrp-main-img');
  var lightbox = document.getElementById('vrp-lightbox');
  var lbImg    = document.getElementById('vrp-lightbox-img');
  var lbClose  = document.getElementById('vrp-lb-close');
  var lbPrev   = document.getElementById('vrp-lb-prev');
  var lbNext   = document.getElementById('vrp-lb-next');

  // Read image data straight off the already-rendered thumbnails/slides
  // instead of a separate script-set array, so the gallery can't get out
  // of sync with what's actually on the page.
  var IMAGES = thumbs
    ? Array.prototype.map.call(thumbs.querySelectorAll('.vrp-thumb'), function (btn) {
        var img = btn.querySelector('img');
        return {
          src: btn.getAttribute('data-full'),
          alt: img ? img.alt : ''
        };
      })
    : [];

  var total        = IMAGES.length;
  var currentIndex = 0;

  function openLightbox(index) {
    if (!lightbox || !IMAGES[index]) return;
    currentIndex = index;
    lbImg.src = IMAGES[index].src;
    lbImg.alt = IMAGES[index].alt;
    lightbox.classList.add('open');
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var sbw = window.innerWidth - document.documentElement.clientWidth;
    if (sbw > 0) document.body.style.paddingRight = sbw + 'px';
  }

  function closeLightbox() {
    if (!lightbox) return;
    lightbox.classList.remove('open');
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
  }

  function navigateLightbox(dir) {
    var next = (currentIndex + dir + total) % total;
    setActive(next);
    lbImg.src = IMAGES[next].src;
    lbImg.alt = IMAGES[next].alt;
  }

  // Active thumb sync — swap main image, update thumb borders
  function setActive(index) {
    if (!IMAGES[index]) return;
    currentIndex = index;
    if (mainImg) {
      // The main image ships with srcset/sizes for the initial responsive
      // load; once we're swapping it by hand, srcset takes priority over
      // src in the browser's eyes, so it has to go or the swap is a no-op.
      mainImg.removeAttribute('srcset');
      mainImg.removeAttribute('sizes');
      mainImg.src = IMAGES[index].src;
      mainImg.alt = IMAGES[index].alt;
    }
    if (thumbs) {
      var btns = thumbs.querySelectorAll('.vrp-thumb');
      btns.forEach(function (btn, i) {
        var on = (i === index);
        btn.classList.toggle('active', on);
        btn.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }
  }

  if (thumbs) {
    thumbs.addEventListener('click', function (e) {
      var btn = e.target.closest('.vrp-thumb');
      if (!btn) return;
      setActive(parseInt(btn.getAttribute('data-index'), 10));
    });
  }

  if (mainEl) {
    mainEl.addEventListener('click', function () {
      openLightbox(currentIndex);
    });
    mainEl.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLightbox(currentIndex); }
    });
  }

  if (lbClose)  lbClose.addEventListener('click', closeLightbox);
  if (lbPrev)   lbPrev.addEventListener('click',  function () { navigateLightbox(-1); });
  if (lbNext)   lbNext.addEventListener('click',  function () { navigateLightbox(1); });
  if (lightbox) lightbox.addEventListener('click', function (e) { if (e.target === lightbox) closeLightbox(); });

  document.addEventListener('keydown', function (e) {
    if (!lightbox || !lightbox.classList.contains('open')) return;
    if (e.key === 'Escape')     closeLightbox();
    if (e.key === 'ArrowLeft')  navigateLightbox(-1);
    if (e.key === 'ArrowRight') navigateLightbox(1);
  });

  // Mobile swipe carousel
  var mcTrack = document.getElementById('vrp-mc-track');
  var mcDots  = document.querySelectorAll('.vrp-mc-dot');

  if (mcTrack) {
    mcTrack.addEventListener('scroll', function () {
      var index = Math.round(mcTrack.scrollLeft / mcTrack.offsetWidth);
      mcDots.forEach(function (dot, i) {
        dot.classList.toggle('active', i === index);
      });
    }, { passive: true });

    mcDots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var idx = parseInt(dot.getAttribute('data-index'), 10);
        mcTrack.scrollTo({ left: idx * mcTrack.offsetWidth, behavior: 'smooth' });
      });
    });

    mcTrack.addEventListener('click', function (e) {
      var slide = e.target.closest('.vrp-mc-slide');
      if (!slide) return;
      var idx = parseInt(slide.getAttribute('data-index'), 10);
      openLightbox(idx);
    });
  }

  if ('IntersectionObserver' in window) {
    var revealObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('visible'); revealObs.unobserve(entry.target); }
      });
    }, { threshold: 0.08 });
    document.querySelectorAll('.vrp-fade-up').forEach(function (el) { revealObs.observe(el); });
  } else {
    document.querySelectorAll('.vrp-fade-up').forEach(function (el) { el.classList.add('visible'); });
  }

  // Tall sticky sidebar: adjust top dynamically so bottom of form is reachable on scroll
  var stickyPanel = document.querySelector('.vrp-info-panel');
  if (stickyPanel) {
    var stickyTopMax = 100;
    var stickyOffset = stickyTopMax;
    var stickyLastY  = window.pageYOffset;

    window.addEventListener('scroll', function () {
      var scrollY = window.pageYOffset;
      var panelH  = stickyPanel.offsetHeight;
      var winH    = window.innerHeight;
      var delta   = scrollY - stickyLastY;

      if (panelH > winH - stickyTopMax) {
        stickyOffset -= delta;
        var minTop = winH - panelH - 20;
        stickyOffset = Math.max(minTop, Math.min(stickyTopMax, stickyOffset));
        stickyPanel.style.top = stickyOffset + 'px';
      } else {
        stickyPanel.style.top = stickyTopMax + 'px';
      }

      stickyLastY = scrollY;
    }, { passive: true });
  }

  // Warm the browser cache for every full-size gallery photo shortly after
  // load, so clicking a thumbnail swaps the main image instantly instead of
  // waiting on a fresh network request.
  function prefetchGalleryImages() {
    IMAGES.forEach(function (img) {
      var warm = new Image();
      warm.src = img.src;
    });
  }

  if ('requestIdleCallback' in window) {
    requestIdleCallback(prefetchGalleryImages, { timeout: 2000 });
  } else {
    setTimeout(prefetchGalleryImages, 1000);
  }

})();
